import { IResultMessage } from "./responses";

/**
 * Výsledek úkolu zpracovaného na pozadí na aplikačním serveru
 * @includeToDoc
 */
export interface ITaskResultDetail {
    /**
     * Dodatečné parametry
     */
    readonly extraParameters: IRunMethodParamsCallerInfo;

    /**
     * Hlášky vytvořené během zpracování úlohy
     */
    readonly resultMessages: readonly IResultMessage[];
}

/**
 * Dodatečné informace o spuštěné metodě
 * @includeToDoc
 */
export interface IRunMethodParamsCallerInfo {
    /**
     * Kód formuláře, nad kterým byla metoda spuštěna
     */
    readonly formCode: string | null;
    /**
     * Lokalizační klíč názvu metody
     */
    readonly userLocKey?: string | null;
    /**
     * Id objektů, nad kterými metoda běžela
     */
    readonly objectIds: readonly string[] | null;
}
